const NOTIFICATION_STRINGS = {
  WORK_ORDER_CREATED: 'Work Order saved.',
  WORK_ORDER_UPDATED: 'Changes saved.',
  DUPLICATE_BUTTON: 'Duplicate',
  PRINT_PDF_BUTTON: 'Print PDF',
  ERROR_TITLE: 'Unable to save Work Order.',
  ERROR_MESSAGE:
    'An error prevented your Work Order from being saved. Please try again.',

  CONTACT_BUTTON: 'Contact Support',
  // Delete operation messages
  DELETING_WORK_ORDER_MESSAGE: 'Deleting Work Order...',
  DELETE_SUCCESS: 'Work Order deleted successfully.',
  DELETE_ERROR: 'Unable to delete Work Order.',
  DELETE_CONFIRM_TITLE: 'Delete Work Order?',
  DELETE_ERROR_TITLE: 'Unable to delete Work Order.',
  DELETE_ERROR_MESSAGE:
    'An error prevented your Work Order from being deleted. Please try again.',
  // PDF export messages
  DOWNLOADING_PDF_MESSAGE: 'Loading PDF...',
  PDF_ERROR_TITLE: 'Unable to create PDF.',
  PDF_ERROR_MESSAGE:
    'An error prevented your PDF from being created. Please try again.',
  PDF_TRY_AGAIN_BUTTON: 'Try Again',
  // View Work Order button
  VIEW_WORK_ORDER_BUTTON: 'View Work Order'
};

export default NOTIFICATION_STRINGS;
